import React from "react"
import { observer } from "mobx-react"
import { billingStore } from "../../app/stores"
import { Button } from "../../lib"
import StripeCardForm from "./StripeCardForm"

const UpdateCard = ({ match, history, push }) => {
  return (
    <div>
      <p>
        To update your card simply enter your card details in the form below. Or go back to
        {" "}
        <Button styleType="text" to="/account/billing">
          Billing Details
        </Button>
        .
      </p>
      <StripeCardForm
        error={billingStore.error}
        saving={billingStore.saving}
        onSubmit={form => {
          return billingStore
            .updateCard({
              number: form.number.value,
              exp_month: form.exp_month.value,
              exp_year: form.exp_year.value,
              cvc: form.cvc.value,
            })
            .then(() => {
              if (history) {
                history.push("/account/billing")
              } else if (push) {
                push("/account/billing")
              }
            })
        }}
      />
    </div>
  )
}

export default observer(UpdateCard)



// WEBPACK FOOTER //
// ./src/account/billing/UpdateCard.js